import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import Translator from "@/utils/common/Translator.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";

export default class StringValueFormatter extends AbsEditViewValueFormatter
{
  private static _instance: StringValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new StringValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (value && typeof value === 'object')
      return Translator.getName(value[CommonFieldIds.NAME1], value[CommonFieldIds.NAME2])
    return value ? value : "";
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    return value ? value : "";
  }
}
